var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM17.5555 8.22222C17.5555 7.36311 16.859 6.66667 15.9999 6.66667C15.1408 6.66667 14.4444 7.36311 14.4444 8.22222V14.272H8.3954C7.53629 14.272 6.83984 14.9685 6.83984 15.8276C6.83984 16.6867 7.53629 17.3831 8.3954 17.3831H14.4444V23.7778C14.4444 24.6369 15.1408 25.3333 15.9999 25.3333C16.859 25.3333 17.5555 24.6369 17.5555 23.7778V17.3831H23.6053C24.4644 17.3831 25.1608 16.6867 25.1608 15.8276C25.1608 14.9685 24.4644 14.272 23.6053 14.272L17.5555 14.272V8.22222Z",
    fill: "currentColor"
  })));
};
export default SvgAdd;